export default __webpack_public_path__ + "static/media/video-player-blue.2144103d.svg";